import { useEffect } from 'react';
import axios from 'axios';
import { useAppStore } from '../store/useAppStore';

export function useSystemHealth() {
  const setSystemHealth = useAppStore((s) => s.setSystemHealth);

  useEffect(() => {
    async function check() {
      try {
        await axios.get('/api/health', { timeout: 5_000 });
        setSystemHealth({ status: 'healthy', checkedAt: new Date().toISOString() });
      } catch {
        setSystemHealth({ status: 'degraded', checkedAt: new Date().toISOString() });
      }
    }

    void check();
    const id = setInterval(() => void check(), 60_000);
    return () => clearInterval(id);
  }, [setSystemHealth]);
}
